import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-night" data-id="element-39" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-40" data-mp="1gcxsapvh5c2f">
        <h2 className="text-center font-display text-[1.75rem] font-semibold tracking-tight text-parchment sm:text-4xl" data-id="element-41" data-mp="1gauql8kyluhv">
          Lo que más nos preguntan
        </h2>

        <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-42" data-mp="291wcdsj5qoad">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-2xl border border-night-line bg-night-panel" data-id="element-43" data-mp="1z3ym6zhqmhf4" data-mpi={index}>
                <h3 data-id="element-44" data-mp="no08ujfj1983">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 px-5 py-4 text-left font-sans text-base font-semibold text-parchment sm:gap-6 sm:px-6 sm:py-5 transition-colors duration-150 ease-out hover:text-gold-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft" data-id="element-45" data-mp="nnifpvo5vb4e">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`mt-0.5 h-5 w-5 flex-none text-gold-soft transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-46" data-mp="bi6gp0fnhn6x" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-47" data-mp="3jxq6fph44nh8">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-48" data-mp="3o03bscry6jdh">
                      <p className="px-5 pb-5 font-sans text-[0.95rem] leading-relaxed text-parchment/70 sm:px-6 sm:pb-6" data-id="element-49" data-mp="1koyoymea4nmv">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}